import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=af6b413e&scoped=true"
import script from "./environment.vue?vue&type=script&lang=js"
export * from "./environment.vue?vue&type=script&lang=js"
import style0 from "./environment.vue?vue&type=style&index=0&id=af6b413e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6b413e",
  null
  
)

export default component.exports